<template>
  <details
    class="page-form-list-wrapper"
    open
  >
    <summary> Jump to Form </summary>
    <div class="form-list">
      <div
        v-for="item in formsList"
        :key="item.id"
        class="form-list-item"
      >
        <a :href="`#${item.id}`">- {{ item.name }}</a>
      </div>
    </div>
  </details>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { useProfile } from '@/use/profile';
import { formList } from '@/Utils/formList';

const route = useRoute();
const { currentUser } = useProfile();

const formsList = computed(() => {
  const list = formList.filter((item) => item.path === route.path).filter(item => {
    if (!item.roles) {
      return true;
    }

    return currentUser.value.roles?.some((role: string) => item.roles?.includes(role));
  })
  return list
});
</script>

<style lang="scss">
.page-form-list-wrapper {
  margin-bottom: 10px;
  summary {
      padding: 10px;
      background: #6d509c;
      color: #fff;
      font-size: 16px;
      font-weight: bold;
      border-top-right-radius: 5px;
      border-top-left-radius: 5px;
    }
  a {
    color: #6d509c;

    &:hover {
      color: #1224af;
      text-decoration: none;
    }
  }

  .form-list {
    padding: 10px;
    border: 1px solid #6d509c;
    column-count: 2;
    column-gap: 32px;

    @media (max-width: 576px) {
      column-count: 1;
      column-gap: 0px;
    }
  }
}
</style>